import React from "react";
import {
  staffScheduleRoleShort,
  staffScheduleRoleTitle,
} from "./staffScheduleConstants";

const StaffScheduleRoleChip = ({ role, size = "sm" }) => {
  const code = staffScheduleRoleShort(role);
  const title = staffScheduleRoleTitle(role);

  const sizeClass =
    size === "md"
      ? "h-6 min-w-[2.25rem] px-2 text-[11px]"
      : "h-5 min-w-[2rem] px-1.5 text-[10px]";

  return (
    <span
      title={title !== code ? `${code} — ${title}` : code}
      className={`inline-flex items-center justify-center rounded-md border border-indigo-200 bg-indigo-50 font-bold uppercase tracking-wide text-indigo-800 shadow-sm ${sizeClass}`}
    >
      {code}
    </span>
  );
};

export default StaffScheduleRoleChip;
